/**
 * ModeSwitcher - Toggle between Site and System modes
 * Aurora-style segmented control
 */

import React from 'react';
import { Home, Cpu } from 'lucide-react';

interface ModeSwitcherProps {
  mode: 'site' | 'system';
  onChange: (mode: 'site' | 'system') => void;
  compact?: boolean;
}

export const ModeSwitcher: React.FC<ModeSwitcherProps> = ({ mode, onChange, compact = false }) => {
  return (
    <div className={`flex ${compact ? 'flex-col' : 'flex-row'} bg-gray-100 border-2 border-gray-300 rounded-lg p-1 gap-1`}>
      <button
        onClick={() => onChange('site')}
        className={`
          ${compact ? 'w-full' : 'flex-1'} flex items-center justify-center ${compact ? '' : 'gap-2'} ${compact ? 'p-2' : 'px-4 py-2'} rounded-md
          text-sm font-semibold transition-all duration-200
          ${
            mode === 'site'
              ? 'bg-[#EBFD03] text-black shadow-lg'
              : 'text-gray-600 hover:text-black hover:bg-gray-200'
          }
        `}
        title={compact ? "Site Mode" : undefined}
      >
        <Home className="h-4 w-4" />
        {!compact && <span>Site</span>}
      </button>

      <button
        onClick={() => onChange('system')}
        className={`
          ${compact ? 'w-full' : 'flex-1'} flex items-center justify-center ${compact ? '' : 'gap-2'} ${compact ? 'p-2' : 'px-4 py-2'} rounded-md
          text-sm font-semibold transition-all duration-200
          ${
            mode === 'system'
              ? 'bg-[#EBFD03] text-black shadow-lg'
              : 'text-gray-600 hover:text-black hover:bg-gray-200'
          }
        `}
        title={compact ? "System Mode" : undefined}
      >
        <Cpu className="h-4 w-4" />
        {!compact && <span>System</span>}
      </button>
    </div>
  );
};
